import Modal from '../../../General/Modal';
import React, { useState } from 'react';
import Select from 'react-select';
import { addAllBrand } from '../../../../api/allbrands';
import cogoToast from 'cogo-toast';
import _ from 'lodash';
import './NewBrandModal.scss';
import { getBrandNameWithFallback } from '../lib/brandHelpers';
import { useCatalogHierarchy } from '../../../../hooks/useCatalogHierarchy';

export const NewBrandModal = ({ open, onRequestClose, onSelectBrand, onConflictBrandSelect }) => {
  const { industries, departmentsById, brands } = useCatalogHierarchy();
  const [name, setName] = useState('');
  const [domain, setDomain] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [industry, setIndustry] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [conflicts, setConflicts] = useState([]);

  const onSubmit = async e => {
    e.preventDefault();
    try {
      const { conflicts, brand } = await addAllBrand({
        name: name === '' ? null : name,
        domains: domain ? [{ domain, isPrimary: true, isPreownedRetailer: false }] : undefined,
        logo: logoUrl === '' ? null : logoUrl,
        Industry_id: industry?.value ?? undefined,
        departmentIds: departments.map(department => department.value)
      });

      if (brand) {
        onSelectBrand({
          value: brand.id,
          label: brand.name
        });
        onRequestClose();

        cogoToast.success('New brand created');
      } else if (conflicts?.length) {
        setConflicts(conflicts);
      } else {
        cogoToast.error('There was an issue saving new brand.');
      }
    } catch (error) {
      console.error(error);
      cogoToast.error('There was an issue saving new brand.');
    }
  };

  const handleSelectBrandFromConflict = id => {
    const brand = brands.find(brand => brand.id === Number(id));

    if (brand) {
      onConflictBrandSelect({
        value: brand.id,
        label: getBrandNameWithFallback(brand) ?? name
      });
    }

    onRequestClose();
  };

  if (!open) {
    return null;
  }

  return (
    <Modal title='Add a new brand' close={onRequestClose} className='product-form-new-brand-modal'>
      {conflicts.length > 0 && (
        <div className='conflicts'>
          <h1>It looks like this brand already exists:</h1>
          <ul className='conflicts-list'>
            {Object.entries(_.groupBy(conflicts, 'id')).map(([id, brandConflict]) => (
              <li key={id}>
                Brand #{id}:
                {brandConflict.map(conflict => (
                  <span key={`${conflict.id}-${conflict.field}`}>
                    {conflict.field} '{conflict.value}'
                  </span>
                ))}
                <button type='button' className='use-brand-button' onClick={() => handleSelectBrandFromConflict(id)}>
                  Use this brand
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <form className='new-brand-form' onSubmit={onSubmit}>
        <label>
          Brand name
          <input type='text' value={name} onChange={e => setName(e.target.value)} required />
        </label>

        <label>
          Domain
          <input type='text' value={domain} onChange={e => setDomain(e.target.value)} />
        </label>

        <label>
          Logo URL
          <input type='url' value={logoUrl} onChange={e => setLogoUrl(e.target.value)} />
        </label>

        <label>
          Industry
          <Select
            options={industries.map(industry => ({ value: industry.id, label: industry.name }))}
            placeholder='Select an industry'
            value={industry}
            onChange={option => setIndustry(option)}
          />
        </label>

        <label>
          Departments
          <Select
            isMulti
            options={Object.values(departmentsById).map(department => ({ value: department.id, label: department.name }))}
            placeholder='Select a department'
            value={departments}
            onChange={option => setDepartments(option)}
          />
        </label>

        <button type='submit'>Add brand</button>
      </form>
    </Modal>
  );
};
